import type { ApiResponse } from "./api-response"

export const parseResponse = async <T>(res: Response): Promise<T> => {
  const body: ApiResponse<T> = await res.json()

  if (!res.ok || !body.success) {
    throw new Error(body.message ?? `Request failed with status ${res.status}`)
  }

  if (body.data === undefined) {
    throw new Error("No data in response")
  }

  return body.data
}

/** Success envelope without requiring `data` (e.g. DELETE with empty or null payload). */
export const parseSuccessResponse = async (res: Response): Promise<void> => {
  if (res.status === 204) return

  const body: ApiResponse<unknown> = await res.json()

  if (!res.ok || !body.success) {
    throw new Error(body.message ?? `Request failed with status ${res.status}`)
  }
}
